/**
 * Utility functions for URL handling
 */

/**
 * Build a URL with a redirect_url query parameter if it exists
 * @param basePath - The base path for the URL
 * @param redirectUrl - The redirect URL to append as a query parameter
 * @returns The URL with redirect_url parameter if provided
 */
export const buildAuthUrl = (basePath: string, redirectUrl?: string | null): string => {
  if (!redirectUrl) {
    return basePath;
  }

  const separator = basePath.includes('?') ? '&' : '?';
  return `${basePath}${separator}redirect_url=${encodeURIComponent(redirectUrl)}`;
};

/**
 * Extract the redirect URL from URLSearchParams
 * @param searchParams - URLSearchParams object
 * @returns The redirect URL or null if not found
 */
export const getRedirectUrl = (searchParams: URLSearchParams): string | null => {
  return searchParams.get('redirect_url');
};
